import annotations from './annotations';
import state from './state';

export default {
	fileName: 'demo.epub',
	annotations,
	state
};
